import { serializeJsonLd } from './serializeJsonLd.js';

const normalizeHost = (host) => {
  if (typeof host !== 'string' || host.trim() === '') {
    throw new TypeError('Structured data host must be a non-empty string');
  }

  return host.trim().replace(/\/+$/, '');
};

const absoluteUrl = (host, url) => (url.startsWith('/') ? `${normalizeHost(host)}${url}` : url);

export const getOrganizationId = (host) => `${normalizeHost(host)}/#organization`;

export const buildOrganizationData = ({
  host,
  name,
  description,
  logo,
  foundingDate,
  address,
  email,
  sameAs,
}) => ({
  '@context': 'https://schema.org/',
  '@type': 'OnlineStore',
  '@id': getOrganizationId(host),
  name,
  url: `${normalizeHost(host)}/`,
  logo: absoluteUrl(host, logo),
  ...(description ? { description } : {}),
  ...(foundingDate ? { foundingDate } : {}),
  ...(address ? { address: { '@type': 'PostalAddress', ...address } } : {}),
  ...(email
    ? {
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          email,
        },
      }
    : {}),
  ...(Array.isArray(sameAs) && sameAs.length > 0 ? { sameAs } : {}),
});

export const buildOrganizationJson = (props) => serializeJsonLd(buildOrganizationData(props));
